// Types et helpers purs partagés entre MyOffice (mode normal) et MyOfficeEmbed (mode Arsenal).
// Aucune logique métier ici : uniquement du formatage/affichage.

export interface StandingRow {
  user_id: number;
  username: string;
  rank?: number;
  nhl_team_abbrev?: string | null;
  totgoals?: number;
  totassists?: number;
  totgoals_goalie?: number;
  totassists_goalie?: number;
  totwins_goalie?: number;
  totshutout_goalie?: number;
  tototlosses_goalie?: number;
}

export interface UpcomingEventItem {
  key: string;
  title: string;
  description: string;
  date?: Date;
  ctaLabel?: string;
  ctaPath?: string;
}

export interface TodoItem {
  key: string;
  title: string;
  subtitle: string;
  level: 'high' | 'medium' | 'low';
  path: string;
  cta: string;
}

export interface TradePreview {
  key: string;
  counterpart: string;
  sentSummary: string;
  receivedSummary: string;
  createdAt: string;
}

export const getDaysUntil = (date?: Date) => {
  if (!date) return null;
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfTarget = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  return Math.round((startOfTarget.getTime() - startOfToday.getTime()) / (1000 * 60 * 60 * 24));
};

export const getRelativeDateLabel = (date?: Date, language: 'fr' | 'en' = 'fr') => {
  const days = getDaysUntil(date);
  if (days === null) return language === 'fr' ? 'Date à confirmer' : 'Date TBD';
  if (days < 0) return language === 'fr' ? 'Échéance dépassée' : 'Deadline passed';
  if (days === 0) return language === 'fr' ? "Aujourd'hui" : 'Today';
  if (days === 1) return language === 'fr' ? 'Demain' : 'Tomorrow';
  return language === 'fr' ? `Dans ${days} jours` : `In ${days} days`;
};

export const getPoints = (row?: StandingRow | null) => {
  if (!row) return 0;
  return (
    (row.totgoals || 0) +
    (row.totassists || 0) +
    (row.totgoals_goalie || 0) +
    (row.totassists_goalie || 0) +
    (row.totwins_goalie || 0) +
    (row.totshutout_goalie || 0) +
    (row.tototlosses_goalie || 0)
  );
};

export const compactCurrency = (value: number | null | undefined) =>
  new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: 'CAD',
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value || 0);

export const longDate = (date?: Date, language: 'fr' | 'en' = 'fr') => {
  if (!date) return language === 'fr' ? 'Date à confirmer' : 'Date TBD';
  return date.toLocaleDateString(language === 'fr' ? 'fr-CA' : 'en-CA', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};
